import { csvFormat } from "d3";
import { memo } from "@tanstack/react-table";

export const CsvExportFeature = {
    getDefaultOptions(table) {
        return {
            enableCsv: true,
        };
    },

    createTable(table) {
        if (!table.options.enableCsv) return;

        table.toCsv = memo(
            () => [table.getRowModel().rows, table.options],
            (rows) => {
                return csvFormat(
                    rows.map((row) =>
                        row.getAllCells().reduce((csvRow, cell) => {
                            csvRow[cell.column.id] = cell.getValue();
                            return csvRow;
                        }, {})
                    ),
                    table.options.csv
                ).toWellFormed();
            },
            {}
        );

        table.exportCsv = (filename) => (event) => {
            const csv = table.toCsv();
            let link = document.createElement("a");
            var url = URL.createObjectURL(
                new Blob([BOM + csv], {
                    type: "text/csv;charset=utf-8",
                })
            );
            link.setAttribute("href", url);
            link.setAttribute("download", filename);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        };
    },
};

const BOM = "\ufeff";
